module.exports = __webpack_public_path__ + "img/thumbnail_CommonWombat_f_albino.608fdd62.png";